// extracted by mini-css-extract-plugin
export default {"preview":"ColorTextInput_preview__NTgum"};